import * as Yup from 'yup'
import { Form } from 'react-bootstrap'
import { CustomFormSelect } from '../../../../StyledComponents';
import { Options } from '../SelectOptions';
import { checkRequiredText } from '../ValidationRules';

export const Schema = (settings) => Yup.object().shape({
    preferredLocation1: checkRequiredText(settings),
});

export const PreferredLocationSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, isRequired = false } = props;
    return (
        <>
            <Form.Group className="mb-3" controlId='preferredLocation1'>
                <Form.Label>1. Präferenz{isRequired && '*'}</Form.Label>
                <CustomFormSelect
                    colors={colors}
                    name='preferredLocation1'
                    value={values.preferredLocation1}
                    isValid={touched.preferredLocation1 && !errors.preferredLocation1}
                    isInvalid={touched.preferredLocation1 && errors.preferredLocation1}
                    onChange={handleChange}
                    onBlur={handleBlur}
                >
                    <option value="">Bitte auswählen...</option>
                    {Options.PreferredLocation.map((item, index) => <option key={index}>{item}</option>)}
                </CustomFormSelect>
                <Form.Control.Feedback type="invalid">
                    {errors.preferredLocation1}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId='preferredLocation2'>
                <Form.Label>2. Präferenz</Form.Label>
                <CustomFormSelect
                    colors={colors}
                    name='preferredLocation2'
                    value={values.preferredLocation2}
                    isValid={touched.preferredLocation2 && !errors.preferredLocation2}
                    isInvalid={touched.preferredLocation2 && errors.preferredLocation2}
                    onChange={handleChange}
                    onBlur={handleBlur}
                >
                    <option value="">Bitte auswählen...</option>
                    {Options.PreferredLocation.map((item, index) => <option key={index}>{item}</option>)}
                </CustomFormSelect>
                <Form.Control.Feedback type="invalid">
                    {errors.preferredLocation2}
                </Form.Control.Feedback>
            </Form.Group>
        </>
    );
};